export default function (data) {
    let url = new URL(window.location.origin + window.location.pathname);
    //Then we build a URL Params Object
    if (data.topics.length != 0) {
        url.searchParams.set('topic', (data.topics).toString());
    }
    if (data.country.length != 0) {
        url.searchParams.set('country', (data.country).toString());
    }
    if (data.format.length != 0) {
        url.searchParams.set('format', (data.format).toString());
    }
    if (data.type.length != 0) {
        url.searchParams.set('type', (data.type).toString());
    }
    //Finally we append the url
    window.history.pushState({}, '', url);
}